/*
 * BIONIKA (2026-10-07) — „Csak a készleten lévő változatok" jelölőnégyzet a termékoldalon
 * (product-variant-picker.liquid rendereli a <variant-selects> elé, a variánsok
 * készlet-adatával együtt). Bejelölve elrejti azokat az opcióértékeket, amelyekhez az
 * EDDIGI (előrébb álló, látható) választások mellett nincs készleten lévő változat.
 * Ha a jelenlegi választás nincs készleten, a leginkább egyező készletes változatra vált.
 * Az állapot localStorage-ben marad (a Dawn minden választáskor újrarajzolja a pickert),
 * globálisan töltődik a theme.liquid-ből a quick-add modál miatt.
 */
(function () {
  'use strict';
  if (window.__bnkStockOnly) return;
  window.__bnkStockOnly = true;

  var KULCS = 'bnkStockOnly';
  var LANC = Object.create(null);

  function olvas() { try { return localStorage.getItem(KULCS) === '1'; } catch (e) { return false; } }
  function ir(on) { try { localStorage.setItem(KULCS, on ? '1' : '0'); } catch (e) {} }

  function adat(wrap) {
    if (wrap.__bnkSo) return wrap.__bnkSo;
    var el = wrap.querySelector('[data-bnk-stock-only-data]');
    try { wrap.__bnkSo = JSON.parse(el.textContent); } catch (e) { wrap.__bnkSo = null; }
    return wrap.__bnkSo;
  }

  function rejtett(el) { return !!el.closest('[hidden]'); }

  // Az összes választható elem: { el, oi (opció-index), val, sel, select }
  function elemek(vs, d) {
    var out = [];
    Array.prototype.forEach.call(vs.querySelectorAll('input[type="radio"], select option'), function (el) {
      var nev = el.dataset.optionName;
      var oi = d.options.indexOf(nev);
      if (oi < 0) return;
      var select = el.tagName === 'OPTION' ? el.parentNode : null;
      out.push({
        el: el, oi: oi, val: el.value, select: select, rejtett: rejtett(el),
        sel: select ? el.hasAttribute('selected') || el.selected : el.checked
      });
    });
    return out;
  }

  function visszaallit(vs) {
    Array.prototype.forEach.call(vs.querySelectorAll('.bnk-so-hide'), function (el) {
      el.classList.remove('bnk-so-hide');
    });
    Array.prototype.forEach.call(vs.querySelectorAll('option[data-bnk-so]'), function (o) {
      o.hidden = false; o.disabled = false; o.removeAttribute('data-bnk-so');
    });
  }

  function alkalmaz(wrap) {
    var vs = wrap.nextElementSibling;
    while (vs && vs.tagName !== 'VARIANT-SELECTS') vs = vs.nextElementSibling;
    var d = adat(wrap);
    if (!vs || !d) return;
    var cb = wrap.querySelector('[data-bnk-stock-only-cb]');
    var on = olvas();
    if (cb.checked !== on) cb.checked = on;
    visszaallit(vs);
    if (!on) return;

    var lista = elemek(vs, d);
    var n = d.options.length;
    var sel = new Array(n), lathato = new Array(n);
    lista.forEach(function (x) {
      if (x.sel) sel[x.oi] = x.val;
      if (!x.rejtett) lathato[x.oi] = true;
    });
    var keszlet = d.v.filter(function (v) { return v[1] === 1; }).map(function (v) { return v[0]; });

    function szabad(oi, val) {
      return keszlet.some(function (o) {
        if (o[oi] !== val) return false;
        for (var j = 0; j < oi; j++) {
          if (lathato[j] && sel[j] != null && o[j] !== sel[j]) return false;
        }
        return true;
      });
    }

    var rossz = false;
    lista.forEach(function (x) {
      if (x.rejtett || szabad(x.oi, x.val)) return;
      if (x.sel) { rossz = true; return; }
      if (x.select) { x.el.hidden = true; x.el.disabled = true; x.el.setAttribute('data-bnk-so', ''); }
      else x.el.classList.add('bnk-so-hide');
    });
    if (!rossz) return;

    // A választás nincs készleten: a leghosszabb egyező előtagú készletes változatra váltunk.
    var k = vs.dataset.section || 'x';
    LANC[k] = (LANC[k] || 0) + 1;
    if (LANC[k] > 3) return;
    var legjobb = null, pont = -1;
    keszlet.forEach(function (o) {
      var p = 0;
      for (var j = 0; j < n; j++) {
        if (!lathato[j]) continue;
        if (sel[j] == null || o[j] !== sel[j]) break;
        p++;
      }
      if (p > pont) { pont = p; legjobb = o; }
    });
    if (!legjobb) return;
    var utolso = null;
    lista.forEach(function (x) {
      var kell = legjobb[x.oi] === x.val;
      if (x.select) {
        if (kell) { x.el.selected = true; x.el.setAttribute('selected', 'selected'); if (!x.sel) utolso = x.select; }
        else x.el.removeAttribute('selected');
      } else if (kell !== x.el.checked) {
        x.el.checked = kell;
        if (kell && !x.rejtett) utolso = x.el;
      }
    });
    if (utolso) utolso.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function mind() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bnk-stock-only]'), alkalmaz);
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-bnk-stock-only-cb]')) {
      ir(t.checked);
      LANC = Object.create(null);
      mind();
      return;
    }
    if (e.isTrusted && t && t.closest && t.closest('variant-selects')) LANC = Object.create(null);
  });

  var fut = false;
  new MutationObserver(function (m) {
    if (fut) return;
    var kell = m.some(function (r) { return r.type === 'childList' && r.addedNodes.length; });
    if (!kell) return;
    // Szinkron (mikrotaszk, a festés ELŐTT): setTimeout-tal egy képkockára
    // felvillant a teljes választék a Dawn-újrarajzolás után.
    fut = true;
    try { mind(); } finally { fut = false; }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mind);
  else mind();
})();
